export default "__VITE_PUBLIC_ASSET__c609ca34__"